import { z } from 'zod'

/**
 * `/portfolio/import?step=trades|holdings`. The step rides in the URL so the
 * browser's back button walks from "Review holdings" to "Check trades" the way
 * the page's own back button does. Anything else reads as step 1.
 *
 * Kept out of the screen file: that one calls `createFileRoute`, and a test
 * that imports a schema should not have to drag the route along.
 */
export const IMPORT_STEPS = ['trades', 'holdings'] as const

export const importSearchSchema = z.object({
  step: z.enum(IMPORT_STEPS).default('trades').catch('trades'),
})
